import type { UserPermission } from '@contracts/users/UserPermission';

interface Attributes {
  id: string;
  email: string;
  profiles: ClientUserProfile[];
}

export interface ClientUserProfile {
  name: string;
  phone: string;
  clientId: string;
  childClientIds: string[];
}

export class AuthenticatedClientUser {
  public id: string;
  public name: string;
  public email: string;
  public profiles: ClientUserProfile[];
  public permissions: UserPermission[] = [];

  constructor({ id, email, profiles }: Attributes) {
    this.id = id;
    this.name = email;
    this.email = email;
    this.profiles = profiles;
  }

  get firstClientId() {
    return this.profiles[0].clientId;
  }

  get existsInManyCompanies() {
    if (this.profiles.length === 1) {
      return this.profiles[0].childClientIds.length > 0;
    }
    return this.profiles.length > 1;
  }
}
